"use strict";

import svg4everybody from "svg4everybody";

export default {
    init: svg4everybody,
};
